import { YM_DATE_FORMAT } from "@/constants";
import { API } from "@/lib/api";
import { APIService, FetchListRequest } from "@/services/api";
import { ReadTimesheetEntryContractorVisit } from "@/types/timesheetEntryContractorVisit";
import { formatDate } from "date-fns";

const service = new APIService<ReadTimesheetEntryContractorVisit>(
  API.TimesheetEntries,
);

export const TimesheetEntriesContractorsVisitsService = {
  getList: async (
    fetchParams: FetchListRequest<ReadTimesheetEntryContractorVisit>,
  ) => {
    const json = await service.getList(fetchParams, `/visits`);
    return {
      items: json.items.map((item) => {
        const date = new Date(item.shift_report_date);
        return {
          ...item,
          group: `${item.store_id}-${item.payroll_department_id}-${date.getFullYear()}-${date.getMonth() + 1}`,
          group_month: formatDate(date, YM_DATE_FORMAT),
        };
      }),
      count: json.count,
    };
  },
};
